import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";

const VideoList = () => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    fetch("/videos.json")
      .then((res) => res.json())
      .then((data) => setVideos(data.filter(v => v.type === "Video")));
  }, []);

  return (
    <>
      {videos.map((video) => (
        <article className="entry" key={video.id}>
          <div className="entry-img">
            <ReactPlayer width={"100%"} className="youtubev" url={video.videoUrl} controls={true} />
          </div>
          <h2 className="entry-title">
            <Link to={video.readMoreLink}>{video.title}</Link>
          </h2>
          <div className="entry-meta">
            <ul>
              <li className="d-flex align-items-center">
                <i className="bi bi-person"></i>
                <a href="blog-single.html">{video.author}</a>
              </li>
              <li className="d-flex align-items-center">
                <i className="bi bi-clock"></i>
                <a href="blog-single.html">
                  <time dateTime="2020-01-01">{video.date}</time>
                </a>
              </li>
              <li className="d-flex align-items-center">
                <i className="bi bi-chat-dots"></i>
                <a href="blog-single.html">{video.comments}</a>
              </li>
            </ul>
          </div>
          <div className="entry-content">
            <p>{video.description}</p>
            <div className="read-more">
              <Link to={video.readMoreLink}>Read More</Link>
            </div>
          </div>
        </article>
      ))}
    </>
  );
};

export default VideoList;